import { ChangeEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Grid, Paper } from '@mui/material';

import { useIsSuperUser } from '../auth/hooks/useIsSuperUser';

import LicenseOutputDialog from './LicenseOutputDialog';
import { ServerLicenseForm } from './types';

import CreateServerLicenseForm from './CreateServerLicenseForm';
import { add } from 'date-fns';
import { useCreateServerLicense } from './api/createServerLicense';

const initialLicenseState: ServerLicenseForm = {};

const CreateServerLicensesPage = () => {
  const navigate = useNavigate();
  const isSuperUser = useIsSuperUser();
  const createSystemLicense = useCreateServerLicense({});

  const [dialogOpen, setDialogOpen] = useState(false);
  const [license, setLicense] = useState(initialLicenseState);
  const [createdLicense, setCreatedLicense] = useState('');
  const [isDemoLicense, setIsDemoLicense] = useState(false);
  const [demoLicenseExpiration, setDemoLicenseExpiration] = useState(
    add(new Date(), {
      days: 30,
    })
  );

  if (isSuperUser && process.env.REACT_APP_MODE !== 'LPT') {
    navigate('/');
    return <></>;
  }

  const handleCreateLicense = async () => {
    let currentLicense = { ...license };

    if (isDemoLicense) {
      for (const [key] of Object.entries(currentLicense)) {
        currentLicense[key] = {
          ...currentLicense[key],
          demoExpireDate: demoLicenseExpiration,
        };
      }
    }

    try {
      const response = await createSystemLicense.mutateAsync({
        modules: currentLicense,
      });
      setCreatedLicense(JSON.stringify(response));
      setDialogOpen(true);
    } catch (e) {}
  };

  const handleLicenseChecked = (event: ChangeEvent<HTMLInputElement>) => {
    const { name } = event.target;

    if (license.hasOwnProperty(name)) {
      const { [name]: _, ...newLicense } = license;
      setLicense(newLicense);
    } else {
      setLicense({
        ...license,
        [name]: {
          module: name,
          limit: 1,
        },
      });

      if (name === 'WEATHER') setIsDemoLicense(true);
    }
  };

  const handleLicenseLimitChanged = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    setLicense({
      ...license,
      [name]: {
        module: name,
        limit: parseInt(value),
      },
    });
  };

  const handleDemoLicenseChecked = (event: ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;
    const demoLicenseActive = checked || license.hasOwnProperty('WEATHER');

    setIsDemoLicense(demoLicenseActive);
  };

  const handleDemoExpirationChanged = (date: any) => {
    setDemoLicenseExpiration(date);
  };

  return (
    <>
      <LicenseOutputDialog
        open={dialogOpen}
        createdLicense={createdLicense}
        handleClose={() => setDialogOpen(false)}
      />
      <Grid
        container
        direction='column'
        component={Paper}
        xs={6}
        justifyContent='center'
        alignItems='center'
      >
        <Grid item xs={12}>
          <CreateServerLicenseForm
            license={license}
            isDemoLicense={isDemoLicense}
            demoLicenseExpiration={demoLicenseExpiration}
            handleLicenseChecked={handleLicenseChecked}
            handleLicenseLimitChanged={handleLicenseLimitChanged}
            handleCreateLicense={handleCreateLicense}
            handleDemoLicenseChecked={handleDemoLicenseChecked}
            handleDemoExpirationChanged={handleDemoExpirationChanged}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default CreateServerLicensesPage;
